import { render } from "./Footer.vue?vue&type=template&id=77900bb3&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=77900bb3&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Dominika\\Documents\\programowanie\\stonki\\nidomika.github.io\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77900bb3"]])

export default __exports__